import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import smileys from '#utilities/js/rte/smileys/smileys.js'
import load from './load.js'
import dev_load from './dev_load.js'

export default contract({
  smileys,
  load: array([
    load
  ]),
  dev_load: array([
    dev_load
  ]),
})
